// ─── 🧾 Cassa › Campi da pagare (19/10/2026, mockup «Campi da pagare», approvato) ──
//
// Le partite disdette nell'ultima ora perché i giocatori non si sono trovati: il campo intero lo
// paga chi le organizzava. Una riga per partita, con la tendina del mezzo e «Segna pagato»; pagata,
// la riga se ne va, e la scheda della prenotazione dice «Campo pagato il …».

import { useQuery } from '@tanstack/react-query';
import { formatCents, type CampoDaPagareInElenco } from '@pmo/shared';
import { Link } from 'react-router-dom';
import { chiama } from '../../lib/api.js';
import { Attesa, Guasto } from '../../components/pezzi.js';
import { giornoBreve } from '../../lib/time.js';
import { useSessione } from '../auth/sessione.js';
import { SegnaPagato } from './SegnaPagato.js';

export function usaCampiDaPagare() {
  return useQuery({
    queryKey: ['campi-da-pagare'],
    queryFn: () => chiama<{ items: CampoDaPagareInElenco[] }>('GET', '/court-dues'),
  });
}

export function CampiDaPagare(): React.JSX.Element {
  const { profilo } = useSessione();
  const puoIncassare =
    (profilo?.permissions.includes('manage_payments') ?? false) && profilo?.role !== 'readonly';
  const elenco = usaCampiDaPagare();
  if (elenco.isLoading) return <Attesa cosa="i campi da pagare" />;
  if (elenco.error) return <Guasto errore={elenco.error} />;
  const righe = elenco.data?.items ?? [];
  if (righe.length === 0) return <p className="tenue">Tutti i campi sono stati pagati.</p>;
  return (
    <>
      <p className="tenue">
        Partite disdette all’ultima ora perché i giocatori non si sono trovati: il campo intero lo paga chi le
        aveva organizzate.
      </p>
      <div className="tabella-scorre">
        <table className="tabella">
          <thead>
            <tr>
              <th>Partita</th>
              <th>Campo</th>
              <th>Chi paga</th>
              <th>Cifra</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {righe.map((r) => (
              <tr key={r.bookingId}>
                <td>
                  <Link to={`/calendario?data=${r.date}&scheda=${r.bookingId}`}>
                    {giornoBreve(r.date)} · {r.time}
                  </Link>
                </td>
                <td>{r.courtName}</td>
                <td>
                  <strong>{r.memberName ?? '—'}</strong>
                </td>
                <td>{r.cents === null ? 'la decide la Segreteria' : formatCents(r.cents)}</td>
                <td>
                  {puoIncassare && r.memberId !== null && (
                    <SegnaPagato
                      bookingId={r.bookingId}
                      cents={r.cents}
                      chi={r.memberName ?? 'chi organizzava'}
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
